<template>
  <TableLayout :permissions="['meihui:insight:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="用户ID"><el-input v-model="searchForm.userId" placeholder="用户ID" @keypress.enter.native="search" /></el-form-item>
      <el-form-item label="场景">
        <el-select v-model="searchForm.scene" placeholder="场景" clearable>
          <el-option label="日记" value="diary" />
          <el-option label="手记" value="handnote" />
        </el-select>
      </el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建觉察洞察')" icon="el-icon-plus" v-permissions="['meihui:insight:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:insight:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="userId" label="用户ID" width="100" show-overflow-tooltip />
        <el-table-column prop="diaryId" label="日记ID" width="80" show-overflow-tooltip />
        <el-table-column prop="scene" label="场景" width="80" show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-tag size="small" :type="row.scene === 'handnote' ? 'warning' : 'info'">
              {{ row.scene === 'handnote' ? '手记' : '察觉' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="insightType" label="类型" width="100" show-overflow-tooltip />
        <el-table-column prop="title" label="标题" width="150" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑觉察洞察', row)" icon="el-icon-edit" v-permissions="['meihui:insight:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:insight:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operainsightWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operainsightWindow from './operainsightWindow'
export default {
  name: 'Insight', extends: BaseTable, components: { TableLayout, Pagination, operainsightWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '觉察洞察', api: '/rentHouse/insight', 'field.id': 'id', 'field.main': 'title' })
    this.search()
  }
}
</script>